<template>
  <modal>
    <div class="modal-content">
      <img src="@/assets/images/btn-close.svg" @click="closeChangeRoute()" class="btn-close">
      <h2 class="message text-center text-lg font-bold mb-2">{{ $t('tour_change_route') }}</h2>
      <div v-if="isOtherRoute(routes)">
        <ul class="course">
          <li v-for="(route, index) in routes" v-bind:key="index">
            <template v-if="route.serializeData !== undefined">
              <div class="summary mt-4">
                <div class="mx-2">
                  <div class="float-right pr-4">{{ $t('tour_fare') }} {{ getTotalFareAndCharge(route).toLocaleString() }}{{ $t('tour_yen') }}</div>
                  <div class="pl-2">{{ String(index + 1) }}</div>
                </div>
              </div>
              <div class="route pb-2">
                <route :route="route" :editable="false" />
              </div>
              <a class="button-primary block w-full button-is-small" @click="setRoute(index)">
                {{ $t('tour_change_route_submit') }}
              </a>
            </template>
          </li>
        </ul>
      </div>
      <div v-else class="text-center">
        他の経路が見つかりませんでした
      </div>
    </div>

    <div class="modal-button flex justify-between">
      <a @click="closeChangeRoute()" class="button-secondary block w-full button-is-small">{{ $t('tour_change_route_cancel') }}</a>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from "../atoms/Modal"
import Route from "../molecules/Route"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    Modal,
    Route
  },
  props: {
    changeRouteIndex: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    const routes = this.$store.getters['routes/getAll']
    const route = routes[this.changeRouteIndex]
    const condition = this.$store.getters['condition/getOptions']
    let p = {
      from: this.$store.getters['destinations/getDestination'](this.changeRouteIndex - 1),
      to: this.$store.getters['destinations/getDestination'](this.changeRouteIndex),
      searchType: route.searchType,
      time: moment(route.searchDatetime),
      taxiDistance: condition.taxiDistance,
      sort: condition.sort
    }
    // 最初の目的地であればfromに出発駅をセットしてその間の経路を検索
    if (!p.from) {
      const departure = this.$store.getters['destinations/getDepatureStation']
      p = { ...p, from: departure }
    }
    // 最後の目的地であればtoに到着駅をセットしてその間の経路を検索
    if (!p.to) {
      const arrival = this.$store.getters['destinations/getArrivalStation']
      p = { ...p, to: arrival }
    }
    this.$store.dispatch('routes/searchRouteAll', p)
  },
  methods: {
    setRoute: function (index) {
      const p = {
        index: this.changeRouteIndex,
        serializeData: this.routes[index].serializeData
      }
      this.$store.dispatch('routes/resetRouteList')
      this.$store.dispatch('routes/setSerializeData', p)
      this.$store.dispatch('routes/search')
      this.$emit('closeChangeRoute')
    },
    closeChangeRoute: function () {
      this.$store.dispatch('routes/resetRouteList')
      this.$emit('closeChangeRoute')
    },
    getTotalFareAndCharge: function (route) {
      const price = route.course.Ticket.Price.find(p => p.id == "normal")
      return (parseInt(price.fareSummary, 10) + parseInt(price.chargeSummary, 10))
    },
    isOtherRoute: function (route) {
      if (route.length > 0) {
        for (let i = 0; i < route.length; i++) {
          if (route[i].serializeData !== undefined) {
            return true
          }
        }
        return false
      }
      return true
    }
  },
  computed: {
    ...mapGetters({
      routes: 'routes/getRouteList'
    }),
  }
}
</script>
